import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DIALOG_BUTTONS } from '../../constants';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-crop-dialog.component.html',
  styleUrls: ['./image-crop-dialog.component.scss'],
  standalone: false,
})
export class ImageCropDialogComponent {
  data = inject<{
    title: string;
    imageChangedEvent: Event;
    sharedButtonClass: string;
    sharedButtonText: string;
  }>(MAT_DIALOG_DATA);

  public transform: ImageTransform = {};
  public croppedImage: string = '';
  readonly buttons = DIALOG_BUTTONS;

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
  }

  public getCroppedImage(): string {
    return this.croppedImage;
  }
}
